import { Cells } from 'common/types/scalarSpreadsheet';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { SOURCE_TOTALS_ROW_TARGET } from 'pages/Valuations/approaches/backsolveApproach/SourceRowsTable/sheetAliases';
import { BacksolveApproachAttributes } from 'pages/ValuationsAllocation/types';
import { parseDatabaseValue, toString } from 'utilities';
import { TARGET_VALUE_ALIAS } from './constants';
import { ReverseParserProps } from './type';

const reverseParse = (
  security: any,
  cell: ICell,
  cells: Cells,
  fieldAttributes: BacksolveApproachAttributes,
  allowEmptyValues: boolean
) => {
  const { key } = cell;
  const defaultValue = cell.defaultValue ?? null;
  const type = cell.dbType ?? null;
  const format = cell.format ?? null;
  const value = cells[key as keyof typeof cells] ? cells[key as keyof typeof cells].value : defaultValue;
  const { gridType } = cell;
  const fieldAttributesDecimalPlaces = fieldAttributes[cell.alias as keyof BacksolveApproachAttributes]?.decimal_places;
  const decimalPlaces = Number(fieldAttributesDecimalPlaces ?? cell?.dbDecimalPlaces);

  const calcValue = parseDatabaseValue({
    type,
    value,
    format,
    allowEmptyValues,
    gridType,
    decimalPlaces,
  });
  // eslint-disable-next-line no-param-reassign
  security[cell.alias] = calcValue;
};

const reverseParser = ({ cells, tableData, fieldAttributes, allowEmptyValues }: ReverseParserProps) => {
  const alphabet = ['A', 'B', 'C', 'D'];
  tableData.securitiesBasket.basket.forEach((security: any, index: number) => {
    alphabet.forEach(columnLegend => {
      const cell = cells[`${columnLegend}${index + 2}`];
      reverseParse(security, cell, cells, fieldAttributes, allowEmptyValues);
    });
  });

  const totalsRowNumber = tableData.securitiesBasket.basket.length + 2;
  const targetCell =
    Object.values(cells).find(cell => cell.customKey === SOURCE_TOTALS_ROW_TARGET)
    ?? cells[`D${totalsRowNumber}`];

  if (targetCell?.alias === TARGET_VALUE_ALIAS) {
    const fieldAttributesDecimalPlaces =
      fieldAttributes[TARGET_VALUE_ALIAS as keyof BacksolveApproachAttributes]?.decimal_places;
    const decimalPlaces = Number(fieldAttributesDecimalPlaces ?? targetCell?.dbDecimalPlaces);
    const cellValue =
      cells[targetCell.key as keyof typeof cells]?.value ?? targetCell.value ?? targetCell.defaultValue ?? null;
    const calcValue = parseDatabaseValue({
      type: targetCell.dbType ?? null,
      value: cellValue,
      format: targetCell.format ?? null,
      allowEmptyValues,
      gridType: targetCell.gridType,
      decimalPlaces,
    });
    // eslint-disable-next-line no-param-reassign
    tableData.securitiesBasket.target_value = toString(calcValue);
  }
};

export default reverseParser;
